import * as React from "react"
import i18next from "i18next"

export const CertificateDownloadLayout = (props: {
  title: string
  start_date: string
  onDownload: () => void
}) => {
  return <main className="main">
    <div className="main__inner">
      <article className="page page--page">
        <div className="page__inner">
          <div className="page__content">
            <header className="page-header ph-- ph--generic ph--text ph--secondary">
              <div className="ph__inner container container--m gutter--m">
                <div className="ph__content spacing--l ls-second-item">
                  <h1 className="ph__title typo--xl ff--primary" dangerouslySetInnerHTML={{ __html: props.title}} />
                </div>
              </div>
            </header>
            <section className="block block--listing lst">
              <div className="lst__inner container container--s gutter--m spacing--m">
                <ul className="lst__list">
                  <li className="lst__item">
                    <a className="lst__link" onClick={props.onDownload}>
                      <time className="lst__date typo--s" dateTime={props.start_date}>{props.start_date}</time>
                      <h3 className="lst__title ff--primary typo--ml">{i18next.t("certificate.download")}</h3>
                      <p className="lst__intro">{i18next.t("certificate.find_download")}</p>
                    </a>
                  </li>
                </ul>
              </div>
            </section>
          </div>
        </div>
      </article>
    </div>
  </main>
}
